import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBlog = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 18H18M14 10H18M14 6H18M6 14H18M7.6 10H8.4C8.96005 10 9.24008 10 9.45399 9.89101C9.64215 9.79513 9.79513 9.64215 9.89101 9.45399C10 9.24008 10 8.96005 10 8.4V7.6C10 7.03995 10 6.75992 9.89101 6.54601C9.79513 6.35785 9.64215 6.20487 9.45399 6.10899C9.24008 6 8.96005 6 8.4 6H7.6C7.03995 6 6.75992 6 6.54601 6.10899C6.35785 6.20487 6.20487 6.35785 6.10899 6.54601C6 6.75992 6 7.03995 6 7.6V8.4C6 8.96005 6 9.24008 6.10899 9.45399C6.20487 9.64215 6.35785 9.79513 6.54601 9.89101C6.75992 10 7.03995 10 7.6 10ZM10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgBlog;
